import {getValueFromBrowser} from "./trackingQueryHook.js";
import {internalGetCookie, internalRemoveCookie, internalSetCookie} from "./cookies";

const devDomain = window.location.hostname.includes("stage-winpot.mx") || window.location.hostname.includes("localhost"); // For using dev domain on local host

export const currentDomain = devDomain ? "stage-winpot.mx" : "winpot.mx";

const DELAY_BEFORE_EXPIRATION_FACTOR = 0.8;
const ACTIVITY_CHECK_DELAY = 10 * 1000; // 10 sec
const ACTIVITY_EXPIRATION_DELAY = 30 * 60 * 1000; // 30 min
const MAX_REFRESH_TOKEN_TIMEOUT = 2147483647;

let refreshTimeout;
let activityCheckInterval;

export const getSiteApi = () => `https://api.${currentDomain}/`;
export const REACT_APP_WINPOT_CASINO = `https://${currentDomain}/`;

export const isLoggedIn = () =>
	internalGetCookie('AuthorizationToken');

const forceLogout = () => {
	destroySession().then(() => location.replace('/'));
};

const checkActivityExpiration = () =>
	new Date().getTime() - (+localStorage.getItem('lastRequestTime') || 0) >
	ACTIVITY_EXPIRATION_DELAY;

export const checkRememberUser = () =>
	localStorage.getItem('rememberUser') === 'remember';

export const initializeSession = (sessionData = null) => {
	// Set default language to Spanish. In order to override the accept-language header we need to set the required default language
	internalSetCookie("NEXT_LOCALE", "es", 10);
	if (sessionData) {
		internalSetCookie('tokenExpirationDate', sessionData.expiresIn.tokenExpirationDate, 10);
		internalSetCookie('AuthorizationToken', `Bearer ${sessionData.accessToken}`, 10);
		internalSetCookie('RefreshToken', `Bearer ${sessionData.refreshToken}`, 10);
	}

	const tokenExpirationDate = parseInt(internalGetCookie('tokenExpirationDate'));

	if (!tokenExpirationDate || tokenExpirationDate <= new Date().getTime()) {
		internalRemoveCookie('tokenExpirationDate');
		internalRemoveCookie('AuthorizationToken');
		clearTimeout(refreshTimeout);
		clearInterval(activityCheckInterval);
		return null;
	}

	if (!refreshTimeout) {
		let refreshTokenTimeout = Math.round(
			(tokenExpirationDate - new Date().getTime()) * DELAY_BEFORE_EXPIRATION_FACTOR
		);
		if (refreshTokenTimeout < 0) {
			forceLogout();
			return;
		} else if (refreshTokenTimeout > MAX_REFRESH_TOKEN_TIMEOUT) {
			refreshTokenTimeout = MAX_REFRESH_TOKEN_TIMEOUT;
		}
		refreshTimeout = setTimeout(() => {
			if (checkRememberUser() || !checkActivityExpiration()) {
				const requestData = {
					remember: checkRememberUser(),
				};
				fetch(`${getSiteApi()}player/crm/refreshToken`, {
					method: 'POST',
					headers: {
							'Content-Type': 'application/json',
					},
					body: JSON.stringify(requestData)
				})
				.then((response) => {
					refreshTimeout = undefined;
					initializeSession(response);
				});
			} else {
				forceLogout();
			}
		}, refreshTokenTimeout);
	}

	if (!activityCheckInterval) {
		activityCheckInterval = setInterval(() => {
			if (checkActivityExpiration() && !checkRememberUser()) {
				forceLogout();
				clearInterval(activityCheckInterval);
				activityCheckInterval = 0;
			}
		}, ACTIVITY_CHECK_DELAY);
	}
};

export const removeLocalAuthData = () => {
	localStorage.removeItem('email');
	localStorage.removeItem('userId');
	localStorage.removeItem('lastRequestTime');
	internalRemoveCookie('tokenExpirationDate');
	internalRemoveCookie('AuthorizationToken');
	clearTimeout(refreshTimeout);
	clearInterval(activityCheckInterval);
};

export const destroySession = async () => {
	const authorizationHeader = internalGetCookie('AuthorizationToken');

	if (!authorizationHeader) {
		return Promise.resolve();
	}

	internalRemoveCookie('product');
	sessionStorage.removeItem('prevPath');

	removeLocalAuthData();
	fetch(`${getSiteApi()}player/crm/logout`, {
		method: 'POST',
		headers: {
				'Content-Type': 'application/json',
		},
		body: JSON.stringify({}),
	})
	return true;
};

export const redirectAfterRegistration = () => {
	const spinner = document.querySelector('.spinner');
	spinner?.classList.add('show');
	const userProduct = +getValueFromBrowser('product');
	switch (userProduct) {
		case 1:
			window.location.href = `${REACT_APP_WINPOT_CASINO}casino`;
			break;
		case 2:
			window.location.href = `${REACT_APP_WINPOT_CASINO}sport`;
			break;
		default:
			window.location.href = `${REACT_APP_WINPOT_CASINO}casino`;
			break;
	}
};
